import styled from "styled-components";

export const IconStyled = styled.img`
  max-width: 100%;
  max-height: 100%;
`;
